import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const ChileFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14489'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14489)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V6.53333H0V14Z'
					fill='#EA3B2E'
				/>
				<rect
					width='6.66667'
					height='6.53333'
					fill='#0B48C2'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.3325 3.99469L2.21291 4.77686L2.626 3.49166L1.52096 2.68986L2.89586 2.67773L3.3325 1.40002L3.76914 2.67773L5.14403 2.68986L4.039 3.49166L4.45209 4.77686L3.3325 3.99469Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default ChileFlagIcon;
